<template id="map-template">
  <div class="homeview-realtime-data">
    <div class="header">
      <span class="header-title">实时数据</span>
      <div class="arrow-pic"></div>
    </div>
    <div class="circle-chart">
      <div
        class="task-item"
        v-bind:class="{ item1: index == 0 , item2: index == 1,item3 :index ==2}"
        v-for="(item,index) in realtimeData"
        :key="index"
      >
       <div class="task-icon-wrapper">
          {{item.Extend2}}
          <div class="task-icon"></div>
        </div>
        <div class="task-status">{{item.Extend1}}</div>
        <div class="task-count">{{item.ItemValue}}</div>
      </div>
    </div>
    <div class="trend-chart">
      <div class="echart"></div>
    </div>
  </div>
</template>

<script>
import MyApis from "../../../apis";

export default {
  name: "HomeViewRealtimeData",
  componentName: "HomeViewRealtimeData",
  components: {},
  props: {},
  data() {
    return {
      realtimeData: [],
      timer: null
    };
  },
  methods: {
    searchRealtimeData() {
      let that = this;
      let searchInfo = {
        SysCode: "HomeView",
        Key: "RealTimeData",
      };
      new MyApis.UniformConfigApi()
        .GetConfigItemsListExt(searchInfo)
        .then((r) => {
          r = r.data.Data;
        
          this.realtimeData = r;
        })
        .catch((e) => {
          console.log(e);
          that.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
    searchChartData() {
      let that = this;
      let searchInfo = {
        SysCode: "HomeView",
        Key: "DataFlowTrend",
      };
      new MyApis.UniformConfigApi()
        .GetConfigItemsListExt(searchInfo)
        .then((r) => {
          r = r.data.Data;
      
          that.drawChart(r);
        })
        .catch((e) => {
          console.log(e);
          that.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
    drawChart(data) {
      // eslint-disable-next-line no-undef
      if (!drawPassengerFlowTrend || typeof drawPassengerFlowTrend != "function"
      ) {
        console.error("drawPassengerFlowTrend is not a function");
        return;
      }
      // eslint-disable-next-line no-undef
      var echartInstance = echarts.getInstanceByDom($(".echart")[0]);
      if (echartInstance) echartInstance.dispose();

      // eslint-disable-next-line no-undef
      drawPassengerFlowTrend.call($(".echart")[0], data);
    },
  },
  created() {
    this.searchRealtimeData();
    
  },
  mounted() {
    this.searchChartData();
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      this.realtimeData=[];
      this.searchRealtimeData();
      this.searchChartData();
     // this.searchChartData();
    }, window.$config.app.intervalTime || 300000);
    
  },
  beforeDestroy() {},
  destroyed() {
    clearInterval(this.timer)
  },
};
</script>